<template>
  <li>
    <a
      v-if="item.is_external"
      ref="link"
      :href="item.path"
      target="_blank"
      :id="item.id"
      :class="['flex items-center gap-x-3 rounded-md p-2 text-sm leading-6 cursor-pointer', defaultStyle]">
      <img v-if="item.icon_custom" :src="item.icon_custom" class="w-7 h-7 object-contain" />
      <div v-else class="shrink-0 text-xl">
        <i :class="['fa-sharp fa-regular fa-fw', item.icon]" aria-hidden="true"></i>
      </div>
      <span class="flex-1">{{ item.name }}</span>
      <i v-if="!item.is_published" class="fa-sharp fa-regular fa-fw fa-eye-slash" aria-hidden="true"></i>
      <i v-else-if="!!item.path" class="fa-sharp fa-regular fa-fw fa-external-link" aria-hidden="true"></i>
    </a>
    <RouterLink
      v-else
      ref="link"
      :to="`/${path}`"
      :class="[
        isActive ? `bg-accent-500 hover:bg-accent-500 text-accent-text` : defaultStyle,
        'flex items-center gap-x-3 rounded-md p-2 text-sm leading-6'
      ]">
      <img v-if="item.icon_custom" :src="item.icon_custom" class="w-7 h-7 object-contain" />
      <div v-else :class="['shrink-0 text-xl']">
        <i :class="['fa-sharp fa-regular fa-fw', item.icon]" aria-hidden="true"></i>
      </div>
      <span class="flex-1 truncate">{{ item.name }}</span>
      <i v-if="!item.is_published" class="fa-sharp fa-regular fa-fw fa-eye-slash" aria-hidden="true"></i>
      <i
        v-else-if="isCallToAction"
        class="fa-sharp fa-fw fa-circle-small"
        :class="isActive ? 'text-white' : 'text-red-500'"
        aria-hidden="true"></i>
    </RouterLink>
  </li>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { mapState } from 'pinia'
import { RouterLink } from 'vue-router'
import * as Sentry from '@sentry/vue'

export default {
  components: { RouterLink },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(useSystemStore, ['hub', 'routes']),
    isActive() {
      return this.$route.path === `/${this.item.path}` || this.$route.path.indexOf(`/${this.item.path}/`) === 0
    },
    isCallToAction() {
      return this.item.id ? this.$helpers.pageIsCallToAction(this.item.id, true) : false
    },
    defaultStyle() {
      let light = 'text-white/60 hover:text-white hover:bg-white/10'
      let dark = ''
      if (this.hub.colour_base_text === 'text-black') {
        light = 'text-black/60 hover:text-black hover:bg-black/10'
      }
      if (this.hub.colour_base_text === 'text-accent') {
        light = 'text-accent-500 hover:text-accent-400'
      }
      if (this.hub.colour_base_text_dark === 'text-white') {
        dark = 'dark:text-white/60 dark:hover:text-white dark:hover:bg-white/10'
      }
      if (this.hub.colour_base_text_dark === 'text-black') {
        dark = 'dark:text-black/60 dark:hover:text-black dark:hover:bg-black/10'
      }
      if (this.hub.colour_base_text_dark === 'text-accent') {
        dark = 'dark:text-accent/60 dark:hover:text-accent dark:hover:bg-accent/10'
      }

      return [light, dark].join(' ')
    },
    path() {
      return this.getPath(this.item, []).join('/')
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.item?.id === 'sentryFeedback') {
        const feedback = Sentry.getFeedback()
        feedback?.attachTo(this.$refs.link)
      }
    })
  },
  methods: {
    getPath(item, path) {
      path.push(item.path)

      if (!item.show_tabs) {
        return path
      }

      const nextItem = this.routes.find((r) => r.parent_id === item.id)
      if (!nextItem) {
        return path
      }

      return this.getPath(nextItem, path)
    }
  }
}
</script>
